import {routes, request} from "./"

export function doLogout (commit) {
    return request(commit, routes.admin.logout, true, 'post')
}

export function fetchAdmin (commit) {
    return request(commit, routes.admin.fetch, false)
}

export function createAdmin (commit, data) {
    return request(commit, routes.admin.create, data, 'post')
}


export function updateAdmin (commit, data) {
    return request(commit, routes.admin.update, data, 'post')
}


export function deleteAdmin (commit, data) {
    return request(commit, routes.admin.delete, data, 'post')
}



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/api/admin.js
// module id = 602
// module chunks = 0